import { CheckCircle2 } from 'lucide-react'
import PropTypes from 'prop-types'
import { AdasBox, AdasButton, AdasModal, AdasPaper, AdasTypography } from '@components/wrapper-components'

export const SuccessModal = ({ open, requestNumber, handleClose }) => {
  return (
    <AdasModal
      open={open}
      onClose={handleClose}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
      className='flex items-center justify-center'
    >
      <AdasPaper variant='outlined' className='flex flex-col relative rounded-[3%] p-[20px] min-w-[450px] min-h-[200px]'>
        <CheckCircle2
          style={{
            color: '#09AF00',
            alignSelf: 'center',
            fontSize: '25px'
          }}
        />
        <AdasTypography
          variant='body1'
          className='font-bold text-sm text-center leading-5 mt-[10px] text-[#09AF00] tracking-[0.15000000596046448px]'
        >
          <strong>Request #{requestNumber} submitted</strong>
        </AdasTypography>
        <AdasTypography variant='body1' className='font-normal text-sm text-center leading-5 mt-[20px] tracking-[0.15000000596046448px]'>
          Please ensure all documents are attached to the <br />
          <strong>Quote/WO/Invoice </strong> for a quicker resolution.
        </AdasTypography>
        <AdasBox className='flex justify-center mt-[20px]'>
          <AdasButton onClick={handleClose} variant='contained'>
            CLOSE
          </AdasButton>
        </AdasBox>
      </AdasPaper>
    </AdasModal>
  )
}

SuccessModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired
}
